import { JsonPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { DebugService, IExtra } from 'core-lib';
import { Popover } from 'primeng/popover';

@Component({
    selector: 'app-extra-debugview',
    imports: [JsonPipe, Popover],
    templateUrl: './extra-debugview.component.html',
    styleUrl: './extra-debugview.component.scss'
})
export class ExtraDebugviewComponent {
  @Input() extra:IExtra;
  
 isDebugMode:boolean = false;
 
   constructor(private debug: DebugService) {
     
     this.isDebugMode = this.debug.isDebugMode;
     
  }


}
